define('modules/start/products/landings/activity/view',['require','exports','module','views/BaseView','ldsh!./template'],function(require, exports, module) {
    "use strict";

    var BaseView = require("views/BaseView");

    var Layout = BaseView.extend({
        template: require("ldsh!./template"),
        serialize: function() {
            return {
                "prints": this.productsReport.get("landing_prints"),
                "visits": this.productsReport.get("landing_visits"),
                "conversion": this.productsReport.get("landing_conversion"),
                "conversion_percent": this.productsReport.getLandingsConversionPercent(),
                isAdm: this.isAdm
            };
        }
    });

    module.exports = Layout;
});

